import type { ChartDataFormat } from 'services/chart/types';
import { formatPercentage, formatWithSuffix } from 'services/numberFormat';

import type { BarChartDataItem } from '../BarChart';
import { BarChart } from '../BarChart';

type CompareChartProps = {
  chartData: BarChartDataItem[];
  format: ChartDataFormat;
};

export const CompareChart = ({ chartData, format }: CompareChartProps) => {
  const getFormattedValue = (value: number): string => {
    if (format === 'percentage') {
      const percentageValue = value / 100;
      return percentageValue > 5000 ? ' > 5,000%' : formatPercentage(percentageValue, 2);
    }
    if (!format || format === 'number' || format === 'currency' || format === 'raw') {
      return value < 10 ? formatWithSuffix(value, 2) : formatWithSuffix(value);
    }
    return `${value}${format}`;
  };

  return <BarChart chartData={chartData} format={getFormattedValue} />;
};
